import { defineComponent as p, useSlots as c, createBlock as m, openBlock as d } from "vue";
const _ = /* @__PURE__ */ p({
  inheritAttrs: !1,
  __name: "PassThrough",
  props: {
    alter: { type: Function },
    useRef: {},
    template: { type: Boolean }
  },
  emits: ["children"],
  setup(l, { expose: a, emit: u }) {
    const e = l, n = c(), i = u;
    let o;
    function f() {
      const t = (s) => (i("children", s), s);
      if (e.template)
        return o = n.default, t([]);
      if (e.useRef && e.useRef.templateFn)
        return t(e.useRef.templateFn());
      if (!n.default)
        return t([]);
      let r = n.default({});
      return e.alter && (r = e.alter(r)), t(r);
    }
    return a({
      templateFn: o
    }), (t, r) => (d(), m(f));
  }
});
export {
  _ as default
};
